export default class filterNewsroom {
    /*
     * Fires first
     */
    constructor() {
        // Add events
        this.addEvents();

        this.url = jQuery('.js-p-wrap-posts').data('url');
        this.selected_filters = 0;
    }

    /*
     * Add events
     */
    addEvents(){


         $(document).on('change', '.js-p-filter__input', e => {
            let $currentElement = $(e.currentTarget);
            this.updateFilterOptions($currentElement);
        });

        //Toggle filter mobile
        $('.js-toggle-mobile-filter').on('click', e => {
            e.preventDefault();

            let $filterPosition =  $(e.currentTarget).closest('.listing-actionbar--mobile-filter')

            if (  $('.js-mobile-filter--cloend').length ){
                $('.js-mobile-filter--cloend').appendTo($filterPosition);
            }else{
                $('.js-mobile-filter').clone(true).addClass('js-mobile-filter--cloend').appendTo($filterPosition);
            }

            $('.js-mobile-filter--cloend').slideToggle();
        });

        //Clear filter
        $(document).on('click', '.js-p-filter__clear' , e => {
           e.preventDefault();
            $('.js-p-filter__clear').find('img').toggleClass('rotate-360');
            $('.js-p-filter__input').val('all').trigger('change');
            $('.js-p-filter__post-type').val('all').trigger('change');

            this.selected_filters = 0;

            this.ajaxCall($(e.currentTarget));
        });


        //Run Ajax call when change order
        $(document).on('change', '.js-p-sort-order' , e => {
            let currentOrder = $(e.currentTarget).val();
            $('.js-p-sort-order').val(currentOrder);
            this.ajaxCall($(e.currentTarget));
        });

        // $(document).on('change', '.js-p-filter__input' , e => {
        //     let $currentElement = $(e.currentTarget);
        //     this.current_tax = $currentElement.data('taxonomy');
        //     this.current_term = $currentElement.find('option:selected').data('slug');
        // });

        // Search specific filter
        $(document).on('click', '.js-p-prev-page, .js-p-next-page, .js-p-filter__submit, .js-p-filter__submit-search', e => {
            e.preventDefault();
            this.ajaxCall($(e.currentTarget));
        });
    }

    // Ajax call to get posts, pagination and posts counter
    ajaxCall( $currentElement ){
        let inputsTerms = this.getInputsValues($currentElement.closest('form'));
        let currentPage = $('.js-p-current-page').first().text();
        let order = 'newest'
        let search = $('.js-p-filter__value-search').val();

        // URL update
        if ( this.current_tax != undefined && this.current_term != undefined ) {
            // Update our URL using Regular Expressions (remove double-slashes)
            this.url = this.url.replace(/(?<!:)\/+/gm, '/');
            history.pushState({}, '', this.url + '/' + this.current_tax + '/' + this.current_term);
        } else {
            // Update our URL using Regular Expressions (remove double-slashes)
            this.url = this.url.replace(/(?<!:)\/+/gm, '/');
            history.pushState({}, '', this.url + '/');
        }

        // Calculate pagination
        if( $currentElement.hasClass('js-p-next-page') ) {
            currentPage = parseInt(currentPage) + 1
        } else if( $currentElement.hasClass('js-p-prev-page') ) {
            currentPage = parseInt(currentPage) - 1
        } else {
            currentPage = 1
        }

        // Check order
        if( $currentElement.hasClass('js-p-sort-order') ){
            order = $currentElement.val();
        }

        let data = {
            action: 'filterPress',
            inputsTerms: inputsTerms,
            currentPage: currentPage,
            order: order,
            search: search,
        }

        $.ajax({
            type: 'GET',
            url: ajaxObject.ajax_url,
            dataType: "json",
            data: data,
            beforeSend: () => {
                $('.js-p-wrap-posts').addClass('opacity-40', 'pointer-events-none');
            },
            success: (result) => {

                $('.js-satellite--result-amount').val(result.data.satellite_result_amount);

                $('.js-p-list-post').empty();
                $('.js-listing-actionbar__pagination').html( result.data.pagination );
                $('.js-listing-actionbar__results').html( result.data.posts_counter );
                $('.js-p-wrap-posts').removeClass('opacity-40', 'pointer-events-none');

                let posts = result.data.posts;

                posts.forEach(element => {
                    
                    let category = '';

                    if( element.category ) {
                        category = ' | ' + element.category;
                    }

                    let satelliteClass = "";
                    let satelliteCat = "";
                    if( element.fileType === 'pdf' ) { 
                        satelliteClass == 'js-satellite--click-download'
                        if( element.category ){
                            satelliteCat = 'data-st-download-cat="'+element.category.replace(/(<([^>]+)>)/gi, "")
                        } 
                    }
                     

                    if( element.fileType === 'pdf' ) {
                        satelliteClass == 'js-satellite--click-download';
                        // satelliteCat = 'data-st-download-cat="' + element.category + '"';
                    }

                    let post = '<article class="relative">';

                    if( element.image ) {
                        post += '<a href="' + element.url + '" class="col-span-2">' +
                            '<img loading="lazy" src="' + element.image + '" class="h-[200px] object-contain px-2 mx-auto w-full" alt="' + element.alt + '">' +
                        '</a>';
                    }
                    post += '<div class="px-4 col-span-4">' +
                            '<div class="my-3">' +
                                '<time class="font-bold inline-block" datetime="' + element.date + '">' + element.date + '</time>' + category +
                            '</div>' +
                            '<h4 class="lg:pb-12">' + element.title + '</h4>' +
                            '<a href="' + element.url + '" ' + satelliteCat + ' class="js-cc-post-btn ' + satelliteClass + ' btn-no-bg absolute lg:bottom-0">' + element.button_content + '</a>' +
                        '</div>' +
                    '</article>';

                    $('.js-p-list-post').append(post);

                    // Satellite
                    let idChecked = $( ".js-cc-filter__input:checked" ).attr('id') 
                   
                });

                let form_values = jQuery('.js-mobile-filter form').first().serializeArray();
                let filter_interaction = 'added';
                let default_value_count = 0;

                for(let i=0;i<form_values.length;i++) {
                    let item = form_values[i];

                    if ( item.value !== 'all' ){
                        default_value_count++;
                        form_values[i].value = $('select[name="' + form_values[i].name + '"] option:selected').text().replace(/\r?\n|\r/g, "");
                    }
                }
               
                if ( default_value_count < this.selected_filters ) {
                    filter_interaction = 'removed';
                } else if ( default_value_count == 0 ) {
                    filter_interaction = 'cleared';
                }

                this.selected_filters = default_value_count;

                // let filter_interaction = $currentElement.val()  == 'all' ? 'Clear all' : 'Filter Added/Removed';

                _satellite.track("filter_interaction", {
                    filter_info: form_values,
                    filter_interaction: filter_interaction,
                    results_total: result.data.satellite_result_amount,
                });


                if( $( document ).width() <= 1024 && !$currentElement.hasClass('js-p-filter__clear') ){
                    $('.js-mobile-filter--cloend').slideUp();
                }

                // scroll on the top of page when results are ready on the page
                $('html, body').animate({
                    scrollTop: ($('.js-p-wrap-posts').offset().top - 200),
                },500);
            },
        });
    }

    //Get all inputs value
    getInputsValues($form){
        var taxonomies = new Object();

        //$form.find
        //Collect taxonomies and set it as key
        jQuery('.js-p-filter__input').each((index, element) => {
            let $el = $(element);
            let taxonomyKey = $el.attr('name');
            taxonomies[taxonomyKey] = [];
        });

        //Push terms
        let selected_tax = undefined;
        let selected_term = undefined;
        let selected_count = 0;
        
        jQuery('.js-p-filter__input').each((index, element) => {
            
            let $el = $(element);
            let taxonomy = $el.attr('name');
            let term = $el.val();
            taxonomies[taxonomy].push(term);

            let selected = $el.find('option:selected').data('slug');
            
            if ( selected !== undefined ) {
                selected_count++;
                selected_term = selected;
                selected_tax = $el.data('taxonomy');
            }
        });

        if ( selected_count > 1 ) {
            this.current_tax = undefined;
            this.current_term = undefined;
        } else {
            this.current_tax = selected_tax;
            this.current_term = selected_term;
        }

        return taxonomies;
    }

    updateFilterOptions($currentElement) {
     let selectedFilters = this.getInputsValues($currentElement.closest('form'));

     let urlSegments = window.location.pathname.split('/');
    let languageCode = urlSegments[1]; // Assuming language code is always the second segment


    $.ajax({
        type: 'POST',
        url: ajaxObject.ajax_url,
        dataType: 'json',
        data: {
            action: 'update_smart_filters',
            selectedFilters: selectedFilters,
            lang: languageCode
        },
            success: (response) => {
                // Loop through each taxonomy in the response
                for (let taxonomy in response.data) {
                    let options = response.data[taxonomy];
                    let selectElement = $(`select[name="${taxonomy}"]`);
                    let greyedOutOptions = [];

                    // Loop through each term in the taxonomy and update their state
                    for (let termId in options) {
                        let optionElement = selectElement.find(`option[value="${termId}"]`);
                        let shouldGreyOut = !options[termId];

                        if (shouldGreyOut) {
                            optionElement.attr('disabled', 'disabled').addClass('greyed-out');
                            greyedOutOptions.push(optionElement);
                        } else {
                            optionElement.removeAttr('disabled').removeClass('greyed-out');
                        }
                    }
                    
                    greyedOutOptions.forEach(option => {
                        selectElement.append(option);
                    });
                }
            }
    });
}

}
